import React, { useEffect, useState } from 'react';
import { Cascader } from '@duxton-web/ui';
import { CascaderProps } from '@duxton-web/ui/lib';

import Service from '@/lib/App';

interface GrabAreaHierarchySelectorProps {
  onChange: CascaderProps['onChange'];
}

const GrabAreaHierarchySelector: React.FC<GrabAreaHierarchySelectorProps> = ({
  onChange,
}) => {
  const [areaHierarchyOptions, setAreaHierarchyOptions] = useState<
    CascaderProps['options']
  >([]);

  const loadData = (selectedOptions) => {
    if (!selectedOptions?.length) {
      return;
    }

    const targetOption = selectedOptions[selectedOptions.length - 1];
    if (!targetOption) {
      return;
    }

    const parentId = targetOption.value;
    targetOption.loading = true;

    fetchGrabAreaHierarchy(parentId).then((res) => {
      targetOption.loading = false;
      const selectedOptionsPath = selectedOptions.map((item) => item.value);

      setAreaHierarchyOptions((prevAreaOptions) => {
        const updatedData = [...prevAreaOptions];
        const parent = selectedOptionsPath.reduce((pre, cur, inx) => {
          const item = pre.find((item) => item.value === cur);
          if (inx === selectedOptionsPath.length - 1) return item;
          return item.children;
        }, prevAreaOptions);

        if (!res?.length) {
          parent.isLeaf = true;
          return updatedData;
        }

        parent.children = res;
        return updatedData;
      });
    });
  };

  const fetchGrabAreaHierarchy = async (parentID: number) => {
    try {
      const { layer, subLayers } =
        await Service.grabAreaManagement.getGrabAreaHierarchy({
          parentID,
        });
      let options = subLayers?.map((item) => ({
        value: item.areaID,
        label: item.areaName,
        isLeaf: false,
      }));
      if (!layer || !options?.length) {
        return [];
      }
      return [
        {
          label: layer,
          value: -1,
          disabled: true,
        },
        ...options,
      ];
    } catch (e) {
      console.error(e);
      return [];
    }
  };

  useEffect(() => {
    const fetchRootLayer = async () => {
      const options = await fetchGrabAreaHierarchy(0);
      setAreaHierarchyOptions(options);
    };
    fetchRootLayer();
  }, []);

  return (
    <Cascader
      style={{ flex: 1 }}
      options={areaHierarchyOptions}
      placeholder="Please select"
      changeOnSelect
      loadData={loadData}
      onChange={onChange}
    />
  );
};

export default GrabAreaHierarchySelector;
